import * as moment from 'moment';


export class TravelServices {
  id: number;
  cost: {
    value: number,
    currency: {
      id: number,
      name: string
    }
  };
  comment: string;
  date: any;
  details: {
    id: number,
    name: string;
  };
  location: {
    id: number,
  };
  service: {
    id: number,
    name: string,
  };
  status: {
    id: number,
    name: string
  };
  oldStatus: {
    id: number,
    name: string
  };
  supplier: {
    id: number,
    name: string
  };
  paid_amount: number;
  currency: any;
  payment_method: any;
  rooms: any[]

  setFromApiModel(apiModel: any): this {
    this.id = apiModel.id;
    this.cost = apiModel.cost;
    this.comment = apiModel.comment;
    this.date = moment(apiModel.date);
    this.details = apiModel.details;
    this.location = apiModel.location;
    this.service = apiModel.service;
    this.status = apiModel.status;
    this.oldStatus = apiModel.status;
    this.supplier = apiModel.supplier;
    this.paid_amount = apiModel.paid_amount;
    this.currency = apiModel.currency;
    this.payment_method = apiModel.payment_method;
    this.rooms = apiModel.rooms ?
      apiModel.rooms.map(room => {return {...room,
      dateFrom: moment(room.date_from),
        dateTo: moment(room.date_to),
      }})
    : null;
    return this;
  }
}
